'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./~/ipld-eth-tx/src/index.js
// module id = 571
// module chunks = 0